import gql from "graphql-tag";

export const InvoiceDownloadQuery = gql`
query invoice_download($payment_id: ID, $camp_participant_id: ID, $invoice_id: String) {
  invoice_download(payment_id: $payment_id, camp_participant_id: $camp_participant_id, invoice_id: $invoice_id){
    status
    pdf_file
  }
}`;

export const Invoice_lookupQuery = gql`query invoice_lookup($invoice_foreign_id: String!, $provider: String!){
  invoice_lookup(invoice_foreign_id: $invoice_foreign_id, provider: $provider) {
    status
    provider
    invoice_number
    invoice_foreign_id
    invoice_date_issued
    invoice_date_due
    invoice_amount_total
    invoice_amount_paid
    client_summary
    items_summary
  }
}`;
